// import that from '../main';
import $http from "./http";

//登录
export const submitLogin = data => {
    return $http.post("/base/login/checkUserInfo", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//获取用户信息
export const getUserInfo = data => {
    return $http.post("/base/common/getUserInfo", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//头部--修改密码
export const updatePassword = data => {
    return $http.post("/base/common/updatePassword", data);
};

//获得菜单接口（要权限）
export const getMenuListByRoles = data => {
    return $http.post("/base/menu/getMenuListByRoles", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//demo--设备信息删除
export const delDemoInfo = data => {
    return $http.post("/operation/demo/delDemoInfo", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//菜单管理---获取TreeList树图
export const getMenuTree = data => {
    return $http.post("/base/menu/getMenuTree", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
//菜单管理---新增菜单提交
export const menuTreeAddCommit = data => {
    return $http.post("/base/menu/editMenu", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//菜单管理---获取菜单详情
export const getMenuTreeInfoById = data => {
    return $http.post("/base/menu/getMenuInfoById", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//菜单管理---修改菜单提交
export const menuTreeEditCommit = data => {
    return $http.post("/base/menu/editMenu", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//菜单管理---tree删除菜单
export const menuTreeDeleteCommit = data => {
    return $http.post("/base/menu/delMenu", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//菜单管理---获取table
export const getUrlsByMenuId = data => {
    return $http.post("/base/menu/getUrlsByMenuId", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//菜单管理---table新增保存
export const menuUrlsTableAddCommit = data => {
    return $http.post("/base/menu/editUrl", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

// 菜单管理---table点修改获取资源详情
export const getUrlInfoByResourceId = data => {
    return $http.post("/base/menu/getUrlInfoByResourceId", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

// 菜单管理---table删除
export const delUrl = data => {
    return $http.post("/base/menu/delUrl", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//菜单管理----按钮权限列表
export const getButtonList = data => {
    return $http.post("/base/button/getButtonList", data);
};

//菜单管理----保存按钮权限
export const saveButton = data => {
    return $http.post("/base/button/saveButton", data);
};

//菜单管理----删除按钮权限
export const delButton = data => {
    return $http.post("/base/button/delButton", data);
};

//菜单管理----获取按钮信息
export const getButtonInfoById = data => {
    return $http.post("/base/button/getButtonInfoById", data);
};

//角色管理---获取角色列表
export const getRoleList = data => {
    return $http.post("/base/role/getRoleList", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//角色管理---新增角色保存
export const saveRole = data => {
    return $http.post("/base/role/saveRole", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//角色管理---点击修改获取角色详情
export const getRoleInfoById = data => {
    return $http.post("/base/role/getRoleInfoById", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

// 角色管理---点击删除删除角色
export const delRoleById = data => {
    return $http.post("/base/role/delRoleById", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//角色管理---点击权限获取权限tree
export const getAuthTree = data => {
    return $http.post("/base/role/getAuthTree", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

// 角色管理---保存角色权限tree
export const saveAuthTree = data => {
    return $http.post("/base/role/saveAuthTree", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

// 机构管理---获取机构tree
export const getUnitData = data => {
    return $http.post("/base/unit/getUnitData", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

// 机构管理---新增/修改tree弹出保存
export const saveUnit = data => {
    return $http.post("/base/unit/saveUnit", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//机构管理---修改tree弹出获取详情
export const getUnitInfo = data => {
    return $http.post("/base/unit/getUnitInfo", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//机构管理---删除tree节点
export const deleteUnit = data => {
    return $http.post("/base/unit/deleteUnit", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//机构管理---获取table表数据
export const getListData = data => {
    return $http.post("/base/unit/getListData", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//机构管理---获取新增弹窗内的角色列表list获取
export const getRoleList_unit = data => {
    return $http.post("/base/unit/getRoleList", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//机构管理---table新增弹窗的提交
export const saveUser = data => {
    return $http.post("/base/unit/saveUser", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//机构管理---table内修改按钮点击获取详情
export const getEditUser = data => {
    return $http.post("/base/unit/getEditUser", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//机构管理---table内删除按钮点击、提交
export const deleteUser = data => {
    return $http.post("/base/unit/deleteUser", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//机构管理---重置密码提交
export const resetPass = data => {
    return $http.post("/base/unit/resetPass", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//机构管理---禁用？启用按钮点击
export const setState = data => {
    return $http.post("/base/unit/setState", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//刷新Redis
export const refreshRedis = data => {
    return $http.post("/collect/refresh_redis/refresh", data);
};

/* 用户共通 */
// 1-1获取公司列表（要权限）--------王智超
export const getUnitList = data => {
    return $http.post("/base/common/getUnitList", data);
};

// 1-2获取户号列表（要权限）--------张东秋
export const getAccountList = data => {
    return $http.post("/collect/common/getAccountList", data);
};

// 1-3获得codelist接口（公开）--------王智超
export const getCodelistByKind = data => {
    return $http.post("/collect/common/getCodelistByKind", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

// 1-4上传图片（有权限）--------王智超
export const uploadAvatar = data => {
    return $http.post("/collect/common/getImg", data, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};

// 1-5获得采集点树（要权限) --王智超
export const getPointList = data => {
    return $http.post("/collect/common/getPointList", data);
};

export const getPointClassColumnKindList = data => {
    return $http.post(
        "/collect/point_design/getPointClassColumnKindList",
        data
    );
};

//基本电费分析 关口列表
export const getRootPointList = data => {
    return $http.post("/collect/electricity_fees/getRootPointList", data);
};

//基本电费分析 基本电费趋势
export const getEighteenDemandFees = data => {
    return $http.post("/collect/electricity_fees/getEighteenDemandFees", data);
};

//基本电费分析 最大需量
export const getEighteenDemand = data => {
    return $http.post("/collect/electricity_fees/getEighteenDemand", data);
};

//基本电费分析 每天的需量
export const getMonthDemand = data => {
    return $http.post("/collect/electricity_fees/getMonthDemand", data);
};

//基本电费分析 每小时的需量
export const getDayDemandFee = data => {
    return $http.post("/collect/electricity_fees/getDayDemand", data);
};
//获取列表
export const getImaginaryPoints = data => {
    return $http.post("/collect/imaginaryPoint/getPointsList", data);
};
//虚点设置列表
export const getimaginaryPointList = data => {
    return $http.post("/collect/imaginaryPoint/list", data);
};
//保存虚点列表
export const getimaginaryPointSave = data => {
    return $http.post("/collect/imaginaryPoint/save", data);
};
//删除虚点列表
export const getimaginaryPointdel = data => {
    return $http.post("/collect/imaginaryPoint/del", data);
};

export const getYearTransformer = data => {
    return $http.post("/collect/needAnalysis/getYearTransformer", data);
};

export const getMonthTransformer = data => {
    return $http.post("/collect/needAnalysis/getMonthTransformer", data);
};
export const getDayTransformer = data => {
    return $http.post("/collect/needAnalysis/getDayTransformer", data);
};

// 删除变压器
export const deleteTransformer = data => {
    return $http.post("/collect/transformer/deleteTransformer", data);
};

// 变压器保存
export const saveTransformer = data => {
    return $http.post("/collect/transformer/saveTransformer", data);
};

// 变压器列表
export const getTransformerListCollect = data => {
    return $http.post("/collect/transformer/getTransformerList", data);
};

// 变压器详细
export const getTransformerInfo = data => {
    return $http.post("/collect/transformer/getTransformerInfo", data);
};

//1-6获取公司树（要权限）--------王智超
export const getUnitTree = data => {
    return $http.post("/base/common/getUnitTree", data);
};

// 查询报警设置
export const getWarnSetByCollectPointId = data => {
    return $http.post("/collect/warnset/getWarnSetByCollectPointId", data);
};

// 获得采集点树（要权限) --王智超
export const getUnitPointList = data => {
    return $http.post("/collect/common/getUnitPointList", data, {
        loadingHide: true
    });
};

// 获取服务器系统时间
export const getSysDate2 = data => {
    return $http.post("/collect/common/getSysDate", data);
};

// 用能报表---日报查询和搜索（要权限) --张东秋
export const getDayData = data => {
    return $http.post("/collect/power_collection/getDayData", data);
};

//用能报表--- 月报查询和搜索（要权限) --张东秋
export const getMonthData = data => {
    return $http.post("/collect/power_collection/getMonthData", data);
};

//用能报表--- 年报查询和搜索（要权限) --张东秋
export const getYearData = data => {
    return $http.post("/collect/power_collection/getYearData", data);
};

//用能报表--- 导出（要权限) --张东秋
export const getExcel = data => {
    return $http.post("/collect/power_collection/getExcel", data, {
        responseType: "blob"
    });
};
//用能报表--- 导出（要权限) --张东秋
export const getPowerExcel = data => {
    return $http.post("/collect/xd_others_excel/getExcel", data, {
        responseType: "blob"
    });
};

export const getYoyList = data => {
    return $http.post("/collect/analysis_yoy/getYoyList", data);
};

//按日
export const getDayData1 = data => {
    return $http.post("/collect/analysis_mom/getDayData", data);
};
//按周
export const getWeekData = data => {
    return $http.post("/collect/analysis_mom/getWeekData ", data);
};
//按月
export const getMonthData1 = data => {
    return $http.post("/collect/analysis_mom/getMonthData", data);
};
//按年
export const getYearData1 = data => {
    return $http.post("/collect/analysis_mom/getYearData", data);
};
//导出
export const getExcel1 = data => {
    return $http.post("/collect/analysis_mom/getExcel", data, {
        responseType: "blob"
    });
};

// 保存报警
export const saveWarnSet = data => {
    return $http.post("/collect/warnset/saveWarnSet", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//
export const getElecExcel = data => {
    return $http.post("/collect/elecexcel/get", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//
export const saveElecExcel = data => {
    return $http.post("/collect/elecexcel/save", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//楼号维护 保存或修改(要权限)---------------李鸿飞
export const saveBuild = data => {
    return $http.post("/business/building/saveBuild", data);
};

//楼号维护 查询列表(要权限)---------------李鸿飞
export const getBuildList = data => {
    return $http.post("/business/building/getBuildList", data);
};
//楼号维护 删除记录(要权限)---------------李鸿飞
export const deleteBuild = data => {
    return $http.post("/business/building/deleteBuild", data);
};

//业主入住 费用查看
export const getUnitCollectorFee = data => {
    return $http.post("/business/unit_extend/getUnitCollectorFee", data);
};

//水电价格 保存或修改(要权限)---------------李鸿飞
export const saveCharge = data => {
    return $http.post("/business/charge/saveCharge", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//水电价格 查询列表(要权限)---------------李鸿飞
export const getChargeList = data => {
    return $http.post("/business/charge/getChargeList", data);
};

/***********公共系统 集中器设计*************/
//下发档案列表页面（要权限)李鸿飞
export const getCentralizedManagement = data => {
    return $http.post("/business/centralizedManagement/listdata", data);
};

//下发档案修改页面（要权限)李鸿飞
export const centralizedManagementEdit = data => {
    return $http.post("/business/centralizedManagement/edit", data);
};

//下发档案修改或新增保存（要权限)李鸿飞
export const centralizedManagementSave = data => {
    return $http.post("/business/centralizedManagement/save", data);
};

//下发档案模块清空档案按钮（要权限)李鸿飞
export const centralizedManagementEmpty = data => {
    return $http.post("/business/centralizedManagement/empty", data);
};

//下发档案模块下发档案按钮（要权限)李鸿飞
export const centralizedManagementIssued = data => {
    return $http.post("/business/centralizedManagement/issued", data);
};

//下发档案模快校时按钮（要权限)李鸿飞
export const centralizedManagementCalibration = data => {
    return $http.post("/business/centralizedManagement/calibration", data);
};

//下发档案模快删除按钮（要权限)李鸿飞
export const centralizedManagementDelete1 = data => {
    return $http.post("/business/centralizedManagement/delete1", data);
};

//发档案模快调定时器监听档案是否下发完成
export const centralizedManagementHideShow = data => {
    return $http.post("/business/centralizedManagement/hideShow", data);
};

//下档案模快重启
export const centralizedManagementResetSave = data => {
    return $http.post("/business/centralizedManagement/resetSave", data);
};

//获取电表号列表（要权限)李鸿飞
export const getCentralizedManagementCollects = data => {
    return $http.post("/business/centralizedManagement/selectCollects", data);
};

//自控采集器 --- 查询列表李鸿飞
export const getConcentratorList = data => {
    return $http.post("/business/waterinfraredtogether/listdata", data);
};

//自控采集器 --- 查询采集器信息 李鸿飞
export const getConcentratorInfo = data => {
    return $http.post("/business/waterinfraredtogether/edit", data);
};

//自控采集器 --- 修改或保存采集器信息 李鸿飞
export const saveConcentratorInfo = data => {
    return $http.post("/business/waterinfraredtogether/save", data);
};

//自控采集器 --- 获取电表信息 李鸿飞
export const getCollectorPointInfo = data => {
    return $http.post("/business/waterinfraredtogether/getCollectorInfo", data);
};

//自控采集器 --- 删除集中器 李鸿飞
export const delCollector = data => {
    return $http.post("/business/waterinfraredtogether/delete", data);
};

//自控采集器 --- 集中器校时 李鸿飞
export const handleCalibration = data => {
    return $http.post("/business/waterinfraredtogether/calibration", data);
};

//自控采集器 --- 集中器校时 李鸿飞
export const handleResetSave = data => {
    return $http.post("/business/waterinfraredtogether/resetSave", data);
};

/****************************************/

//获取权限模块信息
export const getRoleSys_codes = data => {
    return $http.post("/base/role/getRoleSys_codes", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
//获取手机权限模块信息
export const getRolePhoneModule = data => {
    return $http.post("/base/role/getRolePhoneModule", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
//保存权限模块信息
export const saveRoleSys_codes = data => {
    return $http.post("/base/role/saveRoleSys_codes", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
//保存手机权限模块信息
export const saveRolePhoneModule = data => {
    return $http.post("/base/role/saveRolePhoneModule", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
//提现记录
export const getRemindList = data => {
    return $http.post("/business/remind/getRemindList", data);
};
//采集器列表
export const getCollectorList = data => {
    return $http.post("/business/collector/getCollectorList", data);
};
//新增采集器
export const saveCollector = data => {
    return $http.post("/business/collector/saveCollector", data);
};
//查看修改采集器
export const editCollector = data => {
    return $http.post("/business/collector/editCollector", data);
};
//删除采集器
export const deleteCollector = data => {
    return $http.post("/business/collector/deleteCollector", data);
};
//获取采集器类型
export const getCollectorClass = data => {
    return $http.post("/business/collector/getCollectorClass", data);
};
//退场
export const getQuit_room = data => {
    return $http.post("/business/unit_extend/quit_room", data);
};

//退场判断是否又水表电表
export const is_w_e = data => {
    return $http.post("/business/unit_extend/is_w_e", data);
};

// 获取服务器系统时间
export const getSysDate = data => {
    return $http.post("/collect/common/getSysDate", data);
};

// 获取服务器系统时间
export const getSysDate1 = data => {
    return $http.post("/collect/common/getSysDate", data);
};

// 1-3获得户号列表接口（李鸿飞）
export const getAccounts = _ => {
    return $http.post("/collect/common/getAccounts");
};
/* 进线分析 */
// 4-1获取一年内12个月的容量/需量
export const getMonthDemandAndCapacity = data => {
    return $http.post("/collect/needAnalysis/getMonthDemandAndCapacity", data);
};
// 4-2获取一个月内每天的需量
export const getDayDemand = data => {
    return $http.post("/collect/needAnalysis/getDayDemand", data);
};
// 4-3获取一天内每小时的需量
export const getHourDemand = data => {
    return $http.post("/collect/needAnalysis/getHourDemand", data);
};
// 4-4导出一年内12个月的最大需量(李鸿飞)
export const exportMonthDemand = data => {
    return $http.post("/collect/needAnalysis/exportMonthDemand", data, {
        responseType: "blob"
    });
};
// 4-5导出一个月内每天最大需量(李鸿飞)
export const exportDayDemand = data => {
    return $http.post("/collect/needAnalysis/exportDayDemand", data, {
        responseType: "blob"
    });
};
// 4-6导出一天内每小时最大需量(李鸿飞)
export const exportHourDemand = data => {
    return $http.post("/collect/needAnalysis/exportHourDemand", data, {
        responseType: "blob"
    });
};
export const getReportExcel = data => {
    return $http.post("/collect/report/getExcel", data, {
        responseType: "blob"
    });
};
// 4-7查询容量需量电费趋势图
export const getCapacityAndDemandCost = data => {
    return $http.post("/collect/needAnalysis/getCapacityAndDemandCost", data);
};
// 4-8查询一年中每个月目录电量电费趋势图（注：目录电量 目录电费公用一个）
export const getMonthPowerAndCost = data => {
    return $http.post("/collect/needAnalysis/getMonthPowerAndCost", data);
};
// 4-9查询一个月每天目录电量电费趋势图（注：目录电量 目录电费公用一个）
export const getDayPowerAndCost = data => {
    return $http.post("/collect/needAnalysis/getDayPowerAndCost", data);
};
// 4-9查询一天每天每小时目录电量电费趋势图（注：目录电量 目录电费公用一个）
export const getHourPowerAndCost = data => {
    return $http.post("/collect/needAnalysis/getHourPowerAndCost", data);
};
// 4-10 导出一年12个月用电量/电费趋势图（注：目录电量 目录电费公用一个）(李鸿飞)
export const exportMonthPowerAndCost = data => {
    return $http.post("/collect/needAnalysis/exportMonthPowerAndCost", data, {
        responseType: "blob"
    });
};
// 4-11 导出一个月每天用电量/电费趋势图（注：目录电量 目录电费公用一个）(李鸿飞)
export const exportDayPowerAndCost = data => {
    return $http.post("/collect/needAnalysis/exportDayPowerAndCost", data, {
        responseType: "blob"
    });
};
// 4-12 导出一天每小时用电量/电费趋势图（注：目录电量 目录电费公用一个）(李鸿飞)
export const exportHourPowerAndCost = data => {
    return $http.post("/collect/needAnalysis/exportHourPowerAndCost", data, {
        responseType: "blob"
    });
};
// 4-13查询功率因数(李鸿飞)
export const getFactors = data => {
    return $http.post("/collect/needAnalysis/getFactors", data);
};
// 4-14 导出容量需量电费趋势图(李鸿飞)
export const exportCapacityAndDemandCost = data => {
    return $http.post(
        "/collect/needAnalysis/exportCapacityAndDemandCost",
        data,
        {
            responseType: "blob"
        }
    );
};
// 4-15导出功率因数(李鸿飞)
export const exportFactors = data => {
    return $http.post("/collect/needAnalysis/exportFactors", data, {
        responseType: "blob"
    });
};
// 电量分析接口
// 通过日期与采集点id获取用电量
export const getElecInfo = data => {
    return $http.post("/collect/monitor/getElecInfo", data);
};
// 瞬时量趋势分析接口
export const getRealTimeData = data => {
    return $http.post("/collect/monitor/getRealTimeData", data);
};
// 瞬时量趋势分析接口
export const getRealTimeDataNewXin = data => {
    return $http.post("/collect/monitor/getRealTimeDataNew", data);
};
export const getRealTimeDataNew = data => {
    return $http.post("/collect/power_quality/getRealTimeData", data);
};

/************关口维护 */
//关口维护列表
export const getIncomeLineDataList = data => {
    return $http.post("/collect/incomeLine/getIncomeLineDataList", data);
};

//查询采集点列表
export const getCollectPointDateList = data => {
    return $http.post("/collect/incomeLine/getCollectPointDateList", data);
};

//关口增加修改保存
export const saveIncomeLineInfo = data => {
    return $http.post("/collect/incomeLine/saveIncomeLineInfo", data);
};

//删除关口维护信息
export const deleteIncomeLineInfo = data => {
    return $http.post("/collect/incomeLine/deleteIncomeLineInfo", data);
};

//采集系统 电费分析 获取电的年份数据
export const getLoopJobEDataList = data => {
    return $http.post("/collect/loopJobE/getLoopJobEDataList", data);
};

//获取电的年份详细数据
export const getLoopEDataList = data => {
    return $http.post("/collect/loopJobE/getLoopEDataList", data);
};

//获取电的月份详细数据
export const getLoopEDataListM = data => {
    return $http.post("/collect/loopJobE/getLoopEDataListM", data);
};

//采集系统 电费分析 获取电的月份数据
export const getLoopJobEDataListM = data => {
    return $http.post("/collect/loopJobE/getLoopJobEDataListM", data);
};

//采集系统 水费分析 获取水的年份数据
export const getLoopJobWDataList = data => {
    return $http.post("/collect/loopJobW/getLoopJobWDataList", data);
};

//采集系统 水费分析 获取水的月份数据
export const getLoopJobWDataListM = data => {
    return $http.post("/collect/loopJobW/getLoopJobWDataListM", data);
};

//获取水的年份详细数据
export const getLoopWDataList = data => {
    return $http.post("/collect/loopJobW/getLoopWDataList", data);
};

//获取水的月份详细数据
export const getLoopWDataListM = data => {
    return $http.post("/collect/loopJobW/getLoopWDataListM", data);
};

/** 缺陷管理 **/
//获得缺陷管理信息列表
export const getDefectList = data => {
    return $http.post("/operation/defect/getDefectList", data);
};

//缺陷管理保存修改
export const saveDefect = data => {
    return $http.post("/operation/defect/saveDefect", data);
};

//获得缺陷管理详细信息
export const getDefectById = data => {
    return $http.post("/operation/defect/getDefectById", data);
};

//删除缺陷管理信息
export const deleteDefectById = data => {
    return $http.post("/operation/defect/deleteDefectById", data);
};

/** 检修管理 **/
//获得检修计划信息列表
export const getCheckList = data => {
    return $http.post("/operation/check_repair/getCheckList", data);
};
//保存检修计划信息列表
export const saveCheck = data => {
    return $http.post("/operation/check_repair/saveCheck", data);
};
//获取工作负责人
export const getGroupUsers = data => {
    return $http.post("/operation/group/getGroupUsers", data);
};
//获取检修
export const getCheckById = data => {
    return $http.post("operation/check_repair/getCheckById", data);
};
//获取检修结果列表
export const getCheckResultList = data => {
    return $http.post("operation/check_repair/getCheckResultList", data);
};
//获取检修项目信息
export const getCheckResultById = data => {
    return $http.post("/operation/check_repair/getCheckResultById", data);
};
//删除检修项目信息
export const deleteCheckById = data => {
    return $http.post("/operation/check_repair/deleteCheckById", data);
};
//保存检修信息回填
export const saveCheckResult = data => {
    return $http.post("/operation/check_repair/saveCheckResult", data);
};
//保存工作票
export const saveTicket = data => {
    return $http.post("/operation/check_repair/saveTicket", data);
};
//查询工作票
export const getTicketList = data => {
    return $http.post("/operation/check_repair/getTicketList", data);
};
//删除工作票
export const deleteTicket = data => {
    return $http.post("/operation/check_repair/deleteTicket", data);
};
//查看工作票
export const getTicketById = data => {
    return $http.post("/operation/check_repair/getTicketById", data);
};

//保存操作票
export const saveTicketOperation = data => {
    return $http.post("/operation/check_repair/saveTicketOperation", data);
};
//查询操作票
export const getTicketOperationList = data => {
    return $http.post("/operation/check_repair/getTicketOperationList", data);
};
//查看操作票
export const getTicketOperationById = data => {
    return $http.post("/operation/check_repair/getTicketOperationById", data);
};
//删除操作票
export const deleteTicketOperation = data => {
    return $http.post("/operation/check_repair/deleteTicketOperation", data);
};
//添加设备
export const saveCheckRepairParts = data => {
    return $http.post("/operation/check_repair/saveCheckRepairParts", data);
};
//查看设备
export const getCheckRepairParts = data => {
    return $http.post("/operation/check_repair/getCheckRepairParts", data);
};
//保存工作总结
export const saveRepairResultRemark = data => {
    return $http.post("/operation/check_repair/saveRepairResultRemark", data);
};
//查看工作总结
export const getRepairResultRemark = data => {
    return $http.post("/operation/check_repair/getRepairResultRemark", data);
};
//运维系统
//设备管理  获取树
export const getDeviceTree = data => {
    return $http.post("/collect/device/getDeviceTree", data);
};

//设备管理  获取班组列表
export const getGroupList = data => {
    return $http.post("/collect/device/getGroupList", data);
};

//设备管理  获取设备信息
export const getDeviceInfo = data => {
    return $http.post("/collect/device/getDeviceInfo", data);
};

//设备管理  删除设备
export const deleteDevicePointInfo = data => {
    return $http.post("/collect/device/deleteDevicePointInfo", data);
};

//设备管理  保存设备
export const saveDevicePointInfo = data => {
    return $http.post("/collect/device/saveDevicePointInfo", data);
};

//内部保养计划 列表
export const getPlan_inList = data => {
    return $http.post("/collect/plan_in/getPlan_inList", data);
};

//内部保养计划 保存
export const savePlan_in = data => {
    return $http.post("/collect/plan_in/savePlan_in", data);
};

//内部运维执行 列表
export const task_inList = data => {
    return $http.post("/collect/task_in/list", data);
};

export const task_getInfoById = data => {
    return $http.post("/collect/task_in/getInfoById", data);
};

//内部运维执行 执行
export const task_inExecute = data => {
    return $http.post("/collect/task_in/execute", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//内部保养计划 删除
export const deletePlan_in = data => {
    return $http.post("/collect/plan_in/deletePlan_in", data);
};

// 查询树接口
export const getPointTree = data => {
    return $http.post("/collect/point/getPointTree", data);
};

//数据统计列表
export const getStatistics = data => {
    return $http.post("/collect/statistics/getStatistics", data);
};

// 数据统计导出
export const getStatisticsExcel = data => {
    return $http.post("/collect/statistics/getExcel", data, {
        responseType: "blob"
    });
};

// 新增树接口
export const savePointInfo = data => {
    return $http.post("/collect/point/savePointInfo", data);
};

// 删除树接口
export const deletePointInfo = data => {
    return $http.post("/collect/point/deletePointInfo", data);
};

// 采集点维护 获取采集器
export const getCollectListByClassId = data => {
    return $http.post("/collect/point/getCollectListByClassId", data);
};
// 获取绩效数据列表
export const getBudgetList = data => {
    return $http.post("/collect/budget/getBudgetList", data);
};
// 获取水电回路
export const getLoopList = data => {
    return $http.post("/collect/loop/getLoopList", data);
};
// 获取保存水电回路
export const saveLoopInfo = data => {
    return $http.post("/collect/loop/saveLoopInfo", data);
};
// 获取采集点
export const getViewPoint = data => {
    return $http.post("/collect/loop/getViewPoint", data);
};
// 回显
export const getLoopInfo = data => {
    return $http.post("/collect/loop/getLoopInfo", data);
};
// 绩效保存
export const saveBudget = data => {
    return $http.post("/collect/budget/saveBudget", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
// 删除
export const deleteLoop = data => {
    return $http.post("/collect/loop/deleteLoop", data);
};
// 获取人员列表
export const getUserDataList = data => {
    return $http.post("/collect/group/getUserDataList", data);
};
//获取班组列表
export const getGroupDataList = data => {
    return $http.post("/collect/group/getGroupDataList", data);
};
//新增、修改班组管理
export const saveGroupInfo = data => {
    return $http.post("/collect/group/saveGroupInfo", data);
};
//删除班组
export const deleteGroupInfo = data => {
    return $http.post("/collect/group/deleteGroupInfo", data);
};
//查询单个
export const getGroupListById = data => {
    return $http.post("/collect/group/getGroupListById", data);
};
//获取设备维修列表
export const getPlanSbList = data => {
    return $http.post("/collect/plan_sb/getPlanSbList", data);
};
//获取设备维修列表
export const getExaminePlanSbList = data => {
    return $http.post("/collect/plan_sb/getExaminePlanSbList", data);
};
//保存设备维修  提交和修改用的
export const savePlanSbInfo1 = data => {
    return $http.post("/collect/plan_sb/savePlanSbInfo1", data);
};
//保存设备维修  审核那3个人用的
export const savePlanSbInfo2 = data => {
    return $http.post("/collect/plan_sb/savePlanSbInfo2", data);
};
//保存设备维修  这个是 执行
export const savePlanSbInfo3 = data => {
    return $http.post("/collect/plan_sb/savePlanSbInfo3", data);
};
//删除设备维修申请信息
export const deletePlanSbInfo = data => {
    return $http.post("/collect/plan_sb/deletePlanSbInfo", data);
};

// 领导页面--获取图表信息
export const getChartData = data => {
    return $http.post("/collect/chart/getChartData", data);
};

//获得图片验证码接口
export const createCode = data => {
    return $http.post("/business/getValidateCode/createCode", data);
};

//发送短信接口
export const sendCode = data => {
    return $http.post("/business/getValidateCode/sendCode", data);
};

//修改密码接口
export const resetPassword = data => {
    return $http.post("/base/common/resetPassword", data);
};

//数据采集列表
export const getCollectorLastDataList = data => {
    return $http.post("/business/collector/getCollectorLastDataList", data);
};

//数据采集列表
export const datainterface = data => {
    return $http.post("/base/webtalk/cur/datainterface", data);
};
//获取采集点列表
export const getPointsList = data => {
    return $http.post("/collect/account/getPointsList", data);
};

//获取采集点列表
export const getAccountPointList = data => {
    return $http.post("/collect/account/getPointList", data);
};
//获取公司列表
export const getCustomerList = data => {
    return $http.post("/collect/common/getCustomerList", data);
};
//获取电价名称列表
export const getPriceNamelist = data => {
    return $http.post("/collect/account/getPriceNamelist", data);
};
export const getAccountNumberList = data => {
    return $http.post("/collect/account/list", data);
};
//获取保存户号
export const saveAccount = data => {
    return $http.post("/collect/account/save", data);
};
//查看详情
export const getInfoById = data => {
    return $http.post("/collect/account/getInfoById", data);
};
//删除
export const delDemoNumberInfo = data => {
    return $http.post("/collect/account/del", data);
};
//功率因数
export const getFactorByPointId = data => {
    return $http.post("/collect/needAnalysis/getFactorByPointId", data);
};
// 获取变压器
export const getTransformerList = data => {
    return $http.post("/collect/common/getTransformerList", data);
};
//变压器负载
export const getTransformerRateByPointId = data => {
    return $http.post(
        "/collect/needAnalysis/getTransformerRateByPointId",
        data
    );
};
//采集异常
export const getAbnormalList = data => {
    return $http.post("/collect/abnormal/getAbnormalList", data);
};
// 获取采集点
export const getSelectPoint = data => {
    return $http.post("/collect/common/getSelectPoint", data);
};
// 11-1报警列表接口--------王智超
export const getAlarmList = data => {
    return $http.post("/collect/alarm/getAlarmList", data);
};
//报警查询--数据报警--获取列表
export const getDataAlarmList = data => {
    return $http.post("/collect/data_warn/getDataWarnList", data);
};

export const getRealtime = data => {
    return $http.post("/collect/monitor/getRealtime", data);
};
export const getLast = data => {
    return $http.post("/collect/monitor/getLast", data);
};
//获取采集点树
export const getPointTree1 = data => {
    return $http.post("/collect/common/getPointList", data);
};
//获取采集点树
export const getPointTree2 = data => {
    return $http.post("/collect/common/getTreeUnitList", data);
};
//获取瓷件库数据
export const getENVRealData = data => {
    return $http.post("/realData/getENVRealData", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//获取电流
export const getMeterDataList = data => {
    return $http.post("/collect/point_es/getMeterDataList", data);
};

//获取温湿度
export const getENVRealDataList = data => {
    return $http.post("/collect/point_es/getENVRealDataList", data);
};

//获取配电室报警
export const getSwitchWarnList = data => {
    return $http.post("/collect/switch_warn/getSwitchWarnList", data);
};

//采集点成功率
export const getWarnCollectRateList = data => {
    return $http.post(
        "/collect/warn_collect_rate/getWarnCollectRateList",
        data
    );
};
//获取告警与事件
export const getWarnList = data => {
    return $http.post("/collect/warn/getWarnList", data);
};
//处理告警与事件
export const dealWarn = data => {
    return $http.post("/collect/warn/dealWarn ", data);
};
//获取无线测温数据
export const getWireDataList = data => {
    return $http.post("/collect/point_es/getWireDataList", data);
};

//获取局放数据
export const getDischargeDataList = data => {
    return $http.post("/collect/point_es/getDischargeDataList", data);
};

//获取接线图详情数据
export const getWiringMeterDataList = data => {
    return $http.post("/collect/point_es/getWiringMeterDataList", data);
};

export const getMeterData10List = data => {
    return $http.post("/collect/point_es/getMeterData10List", data);
};

export const getProtectDataList = data => {
    return $http.post("/collect/point_es/getProtectDataList", data);
};

//获取采集点列表
export const getPointInfo = data => {
    return $http.post("/collect/elasticsearch/getPointInfo", data);
};

export const getPointInfoES = data => {
    return $http.post("/collect/point_es/getPointInfo", data);
};

export const getElecCustomerInfoES = data => {
    return $http.post("/collect/point_es/getElecCustomerInfo", data);
};

export const getPointNameListES = data => {
    return $http.post("/collect/point_es/getPointNameList", data);
};

//获取表头
export const getHeaderInfoES = data => {
    return $http.post("/collect/point_es/getHeaderInfo", data);
};

//向MySQL中插入数据
export const insetToMysqlES = data => {
    return $http.post("/collect/point_es/insetToMysql", data);
};

//从MYsql中获取数据
export const getDataListES = data => {
    return $http.post("/collect/point_es/getDataList", data);
};

//获取表头
export const getHeaderInfo = data => {
    return $http.post("/collect/elasticsearch/getHeaderInfo", data);
};

//向MySQL中插入数据
export const insetToMysql = data => {
    return $http.post("/collect/elasticsearch/insetToMysql", data);
};

//导入ES
export const insetToEs = data => {
    return $http.post("/collect/elasticsearch/insetToEs", data);
};
//从MYsql中获取数据
export const getDataList = data => {
    return $http.post("/collect/elasticsearch/getDataList", data);
};

//储能总览折线图数据
export const getXdOthersList = data => {
    return $http.post("/collect/point_es/getXdOthersList", data);
};

//功率报表--通过采集点获取功率列表 by day
export const getDayDataForReport = data => {
    return $http.post("/collect/power_report/getDayData", data);
};

//功率报表--通过采集点获取功率列表  by month
export const getMonthDataForReport = data => {
    return $http.post("/collect/power_report/getMonthData", data);
};

//功率报表--通过采集点获取功率列表  by year
export const getYearDataForReport = data => {
    return $http.post("/collect/power_report/getYearData", data);
};

//电量报表--通过采集点获取功率列表 by day
export const getDayDataCollection = data => {
    return $http.post("/collect/power_report/getDayDataCollection", data);
};

//电量报表--通过采集点获取功率列表  by month
export const getMonthDataCollection = data => {
    return $http.post("/collect/power_report/getMonthDataCollection", data);
};

//电量报表--通过采集点获取功率列表  by year
export const getYearDataCollection = data => {
    return $http.post("/collect/power_report/getYearDataCollection", data);
};

//获得日 月 年 用电量
export const getEnergyTotal = data => {
    return $http.post("/collect/monitor/getEnergyTotal", data);
};

//
export const getIncomeLineP = data => {
    return $http.post("/collect/power_report/getIncomeLineP", data);
};

export const getIncomeLinePs = data => {
    return $http.post("/collect/power_comparison/getIncomeLineP", data);
};

//获得能源消耗趋势
export const getEnergyTrend = data => {
    return $http.post("/collect/monitor/getEnergyTrend", data);
};

//获得能源构成
export const getEnergyCompose = data => {
    return $http.post("/collect/monitor/getEnergyCompose", data);
};

//获得能源构成
export const getEnergyComposeTime = data => {
    return $http.post("/collect/monitor/getEnergyComposeTime", data);
};

//获得收益统计
export const getIncome = data => {
    return $http.post("/collect/income/getIncome", data);
};

//综合能耗
export const getEnergyList = data => {
    return $http.post("/collect/energy_analysis/getEnergyList", data);
};

//综合能耗
export const getAmountByMonth = data => {
    return $http.post("/collect/energy_analysis/getAmountByMonth", data);
};

//
export const getConsumption = data => {
    return $http.post("/collect/consumption/getConsumption", data);
};

//能源成本
export const getEnergyPriceList = data => {
    return $http.post("/collect/energy_analysis/getEnergyPriceList", data);
};

//能源成本
export const getAmountPriceByTarget = data => {
    return $http.post("/collect/energy_analysis/getAmountPriceByTarget", data);
};

//能源成本
export const getAmountPriceByMonth = data => {
    return $http.post("/collect/energy_analysis/getAmountPriceByMonth", data);
};

//告警及事件
export const getWarnConfig = data => {
    return $http.post("/collect/warn/getWarnConfig", data);
};

//告警及事件
export const getWarnNotifyUser = data => {
    return $http.post("/collect/warn/getWarnNotifyUser", data);
};

//告警及事件
export const saveWarnNotifyUser = data => {
    return $http.post("/collect/warn/saveWarnNotifyUser", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

// 设备台账维护 —— 获取树
export const getUnitDocTreeList = data => {
    return $http.post("/operation/doc_tree/getUnitDocTreeList", data);
};
// 设备台账维护 —— 获取右侧列表的标题
export const getTitleDocColumList = data => {
    return $http.post("/operation/doc_tree/getTitleDocColumList", data);
};
// 设备台账维护 —— 获取右侧列表的数据
export const getDocColumList = data => {
    return $http.post("/operation/doc_tree/getDocColumList", data);
};
// 设备台账维护 —— 查看
export const getDocTreeColum = data => {
    return $http.post("/operation/doc_tree/getDocTreeColum", data);
};
// 设备台账维护 —— 新增
export const getAddColumId = data => {
    return $http.post("/operation/doc_tree/getAddColumId", data);
};
// 设备台账维护 —— 下拉
export const getSelect = data => {
    return $http.post("/operation/doc_tree/getSelect", data);
};
// 设备台账维护 —— 下拉二
export const getSelectTwo = data => {
    return $http.post("/operation/doc_tree/getTreeType", data);
};
// 设备台账维护 —— 保存
export const docInsert = data => {
    return $http.post("/operation/doc_tree/insert", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
// 设备台账维护 —— 删除
export const delTree = data => {
    return $http.post("/operation/doc_tree/delTree", data);
};
// 设备台账维护 —— 修改查询
export const getUpdateDocTreeColum = data => {
    return $http.post("/operation/doc_tree/getUpdateDocTreeColum", data);
};
// 设备台账维护 —— 修改保存
export const updateTreeColum = data => {
    return $http.post("/operation/doc_tree/updateTreeColum", data);
};
// 设备台账维护 —— 50获取设备
export const getTreeTypeRelation = data => {
    return $http.post("/operation/doc_tree/getTreeTypeRelation", data);
};

//告警及事件
export const saveWarnConfig = data => {
    return $http.post("/collect/warn/saveWarnConfig", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//导出收益统计
export const getIncomeExcel = data => {
    return $http.post("/collect/income/getExcel", data, {
        responseType: "blob"
    });
};

//功率报表--无公式
export const getEnergyComposeH = data => {
    return $http.post("/collect/tree_unit/getEnergyCompose", data);
};

//功率报表--无公式
export const getEnergyTrendH = data => {
    return $http.post("/collect/tree_unit/getEnergyTrend", data);
};

//功率报表--有公式--导出
export const getPowerReportExcel = data => {
    return $http.post("/collect/power_report/getExcel", data, {
        responseType: "blob"
    });
};

//用电量/电费趋势分析--折线图
export const getTargetPriceSumList = data => {
    return $http.post("/collect/target_price/getTargetPriceSumList", data);
};

//用电量/电费趋势分析--饼图
export const getTargetPriceList = data => {
    return $http.post("/collect/target_price/getTargetPriceList", data);
};

//功率日获取列表-部门和区域
export const getPowerDayData = data => {
    return $http.post("/collect/power_comparison/getDayData", data);
};
//功率月获取列表--部门区域
export const getPowerMonthData = data => {
    return $http.post("/collect/power_comparison/getMonthData", data);
};
//功率年获取列表--部门 区域
export const getPowerYearData = data => {
    return $http.post("/collect/power_comparison/getYearData", data);
};

//功率日获取列表-采集点
export const getPointDayData = data => {
    return $http.post("/collect/power_comparison/getPointDayData", data);
};
//功率月获取列表--采集点
export const getPointMonthData = data => {
    return $http.post("/collect/power_comparison/getPointMonthData", data);
};
//功率年获取列表--采集点
export const getPointYearData = data => {
    return $http.post("/collect/power_comparison/getPointYearData", data);
};

//采集点维护--变压器列表
export const getPointTransformerList = data => {
    return $http.post("/collect/point/getTransformerList", data);
};

export const getSankeyList = data => {
    return $http.post("/collect/target_price/getSankeyList", data);
};
export const getMonthList = data => {
    return $http.post("/collect/avg_price/getMonthList", data);
};
export const getMonthRate = data => {
    return $http.post("/collect/avg_price/getMonthRate", data);
};
export const getDayList = data => {
    return $http.post("/collect/avg_price/getDayList", data);
};
export const selectPlanInfoListByPage = data => {
    return $http.post(
        "/operation/ope_inspection/selectPlanInfoListByPage",
        data
    );
};
export const updatePlanState = data => {
    return $http.post("/operation/ope_inspection/updatePlanState", data);
};
export const insertPlanInfo = data => {
    return $http.post("/operation/ope_inspection/insertPlanInfo", data);
};
export const selectPlanInfo = data => {
    return $http.post("/operation/ope_inspection/selectPlanInfo", data);
};
export const deletePlanInfo = data => {
    return $http.post("/operation/ope_inspection/deletePlanInfo", data);
};
export const updatePlanInfo = data => {
    return $http.post("/operation/ope_inspection/updatePlanInfo", data);
};
export const getLeader = data => {
    return $http.post("/operation/rushrepair/getLeader", data);
};
export const saveRushRepair = data => {
    return $http.post("/operation/rushrepair/saveRushRepair", data);
};
export const getRushRepairs = data => {
    return $http.post("/operation/rushrepair/getRushRepairs", data);
};
export const getBackfill = data => {
    return $http.post("/operation/rushrepair/getBackfill", data);
};
export const deleteRushRepair = data => {
    return $http.post("/operation/rushrepair/deleteRushRepair ", data);
};
export const selectTaskList = data => {
    return $http.post("/operation/ope_report_repair/selectTaskList", data);
};
export const insertRepair = data => {
    return $http.post("/operation/ope_report_repair/insertRepair", data);
};
export const updateCheckContent = data => {
    return $http.post("/operation/ope_report_repair/updateCheckContent", data);
};
export const updateState = data => {
    return $http.post("/operation/ope_report_repair/updateState", data);
};
export const selectReportRepairInfo = data => {
    return $http.post(
        "/operation/ope_report_repair/selectReportRepairInfo",
        data
    );
};
export const updateRushRepairId = data => {
    return $http.post("/operation/ope_report_repair/updateRushRepairId", data);
};
export const addBackfill = data => {
    return $http.post("/operation/rushrepair/addBackfill", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
export const selectTaskListByPage = data => {
    return $http.post("/operation/ope_inspection/selectTaskListByPage", data);
};
export const updateTaskInfo = data => {
    return $http.post("/operation/ope_inspection/updateTaskInfo", data);
};

export const selectTaskTree = data => {
    return $http.post("/operation/ope_inspection/selectTask_tree", data);
};

export const insertTaskResult = data => {
    return $http.post("/operation/ope_inspection/insertTask_result", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

//部门能耗分析
export const getJobAndSetByYear = data => {
    return $http.post("/collect/unit_warn_set/getJobAndSetByYear", data);
};
//用能区域分析
export const getCurrentAndLastYear = data => {
    return $http.post("/collect/unit_warn_set/getCurrentAndLastYear", data);
};
//用能区域分析2
export const getRatioYear = data => {
    return $http.post("/collect/unit_warn_set/getRatioYear", data);
};
export const getRatioYearIn = data => {
    return $http.post("/collect/unit_warn_set/getRatioYearIn", data);
};
export const getRatioYearOut = data => {
    return $http.post("/collect/unit_warn_set/getRatioYearOut", data);
};

//获得变电站列表
export const getSubstations = data => {
    return $http.post("/collect/substation/getSubstations", data);
};

//保存变电站
export const saveSubstation = data => {
    return $http.post("/collect/substation/save", data);
};

//删除变电站
export const delSubstation = data => {
    return $http.post("/collect/substation/del", data);
};

//获得计量器具列表
export const getDocCollectors = data => {
    return $http.post("/collect/doccollector/getDocCollectors", data);
};

//保存计量器具
export const saveDocCollector = data => {
    return $http.post("/collect/doccollector/save", data);
};

//删除计量器具
export const delDocCollector = data => {
    return $http.post("/collect/doccollector/del", data);
};

//报警信息列表
export const getJKWarnList = data => {
    return $http.post("/collect/switch_warn/list", data);
};

//能耗成本分析
export const getAccountNameList = data => {
    return $http.post("/collect/unit_account_target/getAccountNameList", data);
};
//能耗成本分析成本分析回显
export const getTargetNameList = data => {
    return $http.post("/collect/unit_account_target/getTargetNameList", data);
};
//查询总费用查询 分页
export const getSumTotalPriceList = data => {
    return $http.post(
        "/collect/unit_account_target/getSumTotalPriceList",
        data
    );
};
//下拉查询指标名称
export const getAccountTargetList = data => {
    return $http.post(
        "/collect/unit_account_target/getAccountTargetList",
        data
    );
};
//删除
export const delAll_value = data => {
    return $http.post("/collect/unit_account_target/delAll_value", data);
};
//保存修改
export const saveOrUpdateValue = data => {
    return $http.post("/collect/unit_account_target/saveOrUpdateValue ", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
export const getParamsList = data => {
    return $http.post("/collect/index_interface/getParamsList", data);
};
export const getIndex_warn = data => {
    return $http.post("/collect/index_interface/getIndex_warn", data);
};
export const getEnergyTrendIndex = data => {
    return $http.post("/collect/index_interface/getEnergyTrend", data);
};
export const getDateActivePower = data => {
    return $http.post("/collect/index_interface/getDateActivePower", data);
};
export const getEnergyTrendYear = data => {
    return $http.post("/collect/index_interface/getEnergyTrendYear", data);
};
export const getEnergyTrendMonth = data => {
    return $http.post("/collect/index_interface/getEnergyTrendMonth", data);
};
export const getEnergyTrendDay = data => {
    return $http.post("/collect/index_interface/getEnergyTrendDay", data);
};

export const getTransformerLoad = data => {
    return $http.post("/collect/index_interface/getTransformerLoad", data);
};
export const getDemandList = data => {
    return $http.post("/collect/index_interface/getDemandList", data);
};
export const getDemandDataList = data => {
    return $http.post("/collect/index_interface/getDemandDataList", data);
};
export const getAreaList = data => {
    return $http.post("/collect/index_interface/getAreaList", data);
};

export const getCategotyTotal = data => {
    return $http.post("/collect/tree_unit_type/getPage", data);
};

export const deleteCategotyTotal = data => {
    return $http.post("/collect/tree_unit_type/delete", data);
};

export const saveOrUpdateCategotyTotal = data => {
    return $http.post("/collect/tree_unit_type/saveOrUpdate", data);
};

// 变压器列表
export const getTransformerPage = data => {
    return $http.post("/collect/transformer/getTransformerPage", data);
};
// 变压器列表
export const getTransformerPointList = data => {
    return $http.post("/collect/transformer/getPointList", data);
};

export const getPointClassMainSelect = data => {
    return $http.post(
        "/collect/collectionItemManage/getPointClassMainSelect",
        data
    );
};

//采集项分类  列表
export const getPointClassList = data => {
    return $http.post("/collect/collectionItem/getPointClassList", data);
};
//采集项分类 保存
export const saveOrUpdatePointClass = data => {
    return $http.post("/collect/collectionItem/saveOrUpdatePointClass", data);
};
// 删除采集项目
export const deletePointClassByPointClassId = data => {
    return $http.post("/collect/collectionItem/deletePointClassByPointClassId", data);
};

export const getPointClassColumnKindSelect = data => {
    return $http.post(
        "/collect/collectionItem/getPointClassColumnKindSelect",
        data
    );
};
export const beatchUpdatePointClassColumnKind = data => {
    return $http.post(
        "/collect/collectionItem/beatchUpdatePointClassColumnKind",
        data,
        {
            headers: {
                "Content-Type": "application/json"
            }
        }
    );
};
export const getPointClassMainList = data => {
    return $http.post(
        "/collect/collectionItemManage/getPointClassMainList",
        data
    );
};

export const getPointClassMainDetail = data => {
    return $http.post("/collect/collectionItemManage/detail", data);
};

export const savePointClassMainDetail = data => {
    return $http.post("/collect/collectionItemManage/saveOrUpdate", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

export const deletePointClass = data => {
    return $http.post("/collect/collectionItemManage/delete", data);
};
//设备离线统计
export const getOfflineMainList = data => {
    return $http.post("/collect/warn/getOfflineMainList", data);
};
export const getJzqList = data => {
    return $http.post("/collect/centralizedManagement/getJzqList", data);
};
export const getOfflineTnList = data => {
    return $http.post("/collect/warn/getOfflineTnList", data);
};
export const getOfflineTnDtlList = data => {
    return $http.post("/collect/warn/getOfflineTnDtlList", data);
};
//设备离线统计详情
export const getOfflineDtlList = data => {
    return $http.post("/collect/warn/getOfflineDtlList", data);
};
//超限报警
export const getWarn_dataList = data => {
    return $http.post("/collect/warn/getWarn_dataList", data);
};
//开关报警
export const getWarn_switchList = data => {
    return $http.post("/collect/warn/getWarn_switchList", data);
};
//综保报警
export const getWarn_zbList = data => {
    return $http.post("/collect/warn/getWarn_zbList", data);
};
export const updateWarn_zb = data => {
    return $http.post("/collect/warn/updateWarn_zb", data);
};
//异常数据
export const getWarnErrDateList = data => {
    return $http.post("/collect/warn/getWarnErrDateList", data);
};

export const getPointListMonitor = data => {
    return $http.post("/collect/realTimeData/getPointList", data);
};
export const getDataMonitor = data => {
    return $http.post("/collect/realTimeData/getData", data);
};

export const getControlPointList = data => {
    return $http.post("/collect/httpFunction/getControlPointList", data);
};

export const setProperty = data => {
    return $http.post("/collect/httpFunction/setProperty", data);
};

export const setPropertyResult = data => {
    return $http.post("/collect/httpFunction/setPropertyResult", data);
};
export const getCommonEnergyList = data => {
    return $http.post("/collect/energy/getCommonEnergyList", data);
};
export const getCommonExcel = data => {
    return $http.post("/collect/energy/getCommonExcel", data, {
        responseType: "blob"
    });
};
export const getTreeCustomerList = data => {
    return $http.post("/collect/tree_unit/getCustomerList", data);
};
export const getCommonPointClassList = data => {
    return $http.post("/collect/common/getPointClassList", data);
};
export const getTreeUnitTypeList = data => {
    return $http.post("/collect/tree_unit/getTreeUnitTypeList", data);
};
//获取部门树
export const getTreeUnitList = data => {
    return $http.post("/collect/tree_unit/getTreeUnitList", data);
};
//根据ID查询公式
export const getTreeUnitById = data => {
    return $http.post("/collect/tree_unit/getTreeUnitById", data);
};
//保存部门树
export const saveTreeUnit = data => {
    return $http.post("/collect/tree_unit/saveTreeUnit", data);
};
//删除部门树
export const delUnit = data => {
    return $http.post("/collect/tree_unit/del", data);
};
//公式保存
export const saveExpress = data => {
    return $http.post("/collect/tree_unit/save", data);
};
export const getTreeUnitTypeTypeList = data => {
    return $http.post("/collect/tree_unit_type/getTreeUnitTypeList", data);
};

export const getTreeUnitListTypes = data => {
    return $http.post("/collect/tree_unit_type/getTreeUnitList", data);
};

export const getMonthData2 = data => {
    return $http.post("/collect/customize_report/getMonthData", data);
};

export const getMonthDataCustomize = data => {
    return $http.post("/collect/customize_report/getMonthDataE", data);
};

export const getExcelE = data => {
    return $http.post("/collect/customize_report/getExcelE", data, {
        responseType: "blob"
    });
};

export const getCustomerPointClassList = data => {
    return $http.post(
        "/collect/pay_unit_price/getCustomerPointClassList",
        data
    );
};
export const getPayUnitPriceList = data => {
    return $http.post("/collect/pay_unit_price/getList", data);
};
export const savePayUnitPrice = data => {
    return $http.post("/collect/pay_unit_price/save", data);
};
export const deletePayUnitPrice = data => {
    return $http.post("/collect/pay_unit_price/delete", data);
};
export const getPayUnitPrices = data => {
    return $http.post("/collect/pay_unit_price/getPriceList", data);
};
export const savePriceList = data => {
    return $http.post("/collect/pay_unit_price/savePriceList", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
export const getPayUnitList = data => {
    return $http.post("/collect/pay_unit/getPayUnitList", data);
};
export const getPayUnitInfo = data => {
    return $http.post("/collect/pay_unit/getPayUnitInfo", data);
};
export const getCommonPointList = data => {
    return $http.post("/collect/common/getCommonPointList", data);
};
export const getPayUnitPriceCodeValue = data => {
    return $http.post("/collect/pay_unit/getPayUnitPriceList", data);
};
export const deletePayUnit = data => {
    return $http.post("/collect/pay_unit/deletePayUnit", data);
};
export const savePayUnit = data => {
    return $http.post("/collect/pay_unit/savePayUnit", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
export const getPayUnitPointClassList = data => {
    return $http.post("/collect/pay_unit_month/getPointClassList", data);
};
export const getPayUnitMonthList = data => {
    return $http.post("/collect/pay_unit_month/getPayUnitMonthList", data);
};
export const getPayUnitMonthInfo = data => {
    return $http.post("/collect/pay_unit_month/getPayUnitMonthInfo", data);
};
export const saveOffMoney = data => {
    return $http.post("/collect/pay_unit_month/saveOffMoney", data);
};
export const getPayUnitMonthExecl = data => {
    return $http.post("/collect/pay_unit_month/getExcel", data, {
        responseType: "blob"
    });
};
export const getExcelCustom = data => {
    return $http.post("/collect/customize_report/getExcel", data, {
        responseType: "blob"
    });
};
export const getPointLossPage = data => {
    return $http.post("/collect/point_loss/getPointLossPage", data);
};
export const deletePointLoss = data => {
    return $http.post("/collect/point_loss/deletePointLoss", data);
};
export const getPointLossDtlList = data => {
    return $http.post("/collect/point_loss/getPointLossDtlList", data);
};
export const savePointLoss = data => {
    return $http.post("/collect/point_loss/savePointLoss", data);
};
export const savePointLossDtl = data => {
    return $http.post("/collect/point_loss/savePointLossDtl", data);
};
export const deletePointLossDtl = data => {
    return $http.post("/collect/point_loss/deletePointLossDtl", data);
};
export const getPointLossRate = data => {
    return $http.post("/collect/point_loss/getPointLossRate", data);
};
export const getWaterPowerMap = data => {
    return $http.post("/collect/power_water/getWaterPowerMap", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
export const getReportConfigList = data => {
    return $http.post("/collect/report/getReportConfigList", data);
};
export const updateConfigList = data => {
    return $http.post("/collect/report/updateConfigList", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
export const getDayGfData = data => {
    return $http.post("/collect/power_comparison/getDayGfData", data);
};
export const getGfMonthData = data => {
    return $http.post("/collect/power_comparison/getGfMonthData", data);
};
export const getGfYearData = data => {
    return $http.post("/collect/power_comparison/getGfYearData", data);
};

// 并网点监测
export const getMonthsBwdjc = data => {
    return $http.post("/collect/monitor/getMonthsBwdjc", data);
};

export const getDaysBwdjc = data => {
    return $http.post("/collect/monitor/getDaysBwdjc", data);
};

export const getHoursBwdjc = data => {
    return $http.post("/collect/monitor/getHoursBwdjc", data);
};

// 消纳率分析
export const getAbsorptiveRateParams = data => {
    return $http.post("/collect/absorptive_rate/getAbsorptiveRateParams", data);
};

export const getActivePowerSum = data => {
    return $http.post("/collect/absorptive_rate/getActivePowerSum", data);
};

export const getAbsorptiveRateList = data => {
    return $http.post("/collect/absorptive_rate/getAbsorptiveRateList", data);
};

export const getAbsorptiveRateMonth = data => {
    return $http.post("/collect/absorptive_rate/getAbsorptiveRateMonth", data);
};
export const getAbsorptiveRateYear = data => {
    return $http.post("/collect/absorptive_rate/getAbsorptiveRateYear", data);
};
export const getTransformerIndex = data => {
    return $http.post("/collect/absorptive_rate/getTransformerIndex", data);
};

export const getActivePowerIndex = data => {
    return $http.post("/collect/absorptive_rate/getActivePowerIndex", data);
};

export const getCurrentElecList = data => {
    return $http.post("/collect/monitor/getCurrentElecList", data);
};

export const getCurrentMonthsFdl = data => {
    return $http.post("/collect/monitor/getCurrentMonthsFdl", data);
};
// 电费结算
export const getChargeListElec = data => {
    return $http.post("/collect/electric_charge/getChargeList", data);
};
export const deleteElectricCharge = data => {
    return $http.post("/collect/electric_charge/deleteElectricCharge", data);
};
export const getElecPowerExcel = data => {
    return $http.post("/collect/report/getPowerExcel", data, {
        responseType: "blob"
    });
};
export const getTargetUnitElec = data => {
    return $http.post("/collect/electric_charge/getTargetUnit", data);
};
export const getDefaultCalculate = data => {
    return $http.post("/collect/electric_charge/getDefaultCalculate", data);
};
export const saveElectricChargeInfo = data => {
    return $http.post("/collect/electric_charge/save", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
export const getElectricChargeInfo = data => {
    return $http.post("/collect/electric_charge/getElectricChargeInfo", data);
};

export const getElectricChargePriceList = data => {
    return $http.post(
        "/collect/electricChargePrice/getElectricChargePriceList",
        data
    );
};
export const updateElectricChargePriceList = data => {
    return $http.post("/collect/electricChargePrice/beachUpdate", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
export const getMonTree = data => {
    return $http.post("/collect/mon/getMonTree", data);
};
export const getMonClassTree = data => {
    return $http.post("/collect/monClass/getMonClassTree", data);
};
export const getUnitConsumption = data => {
    return $http.post("/collect/monPower/getUnitConsumption", data);
};
export const getMonthUnitConsumption = data => {
    return $http.post("/collect/monPower/getMonthUnitConsumption", data);
};
export const getRealCarbon = data => {
    return $http.post("/collect/index/getRealCarbon", data);
};
export const getRealMonthData = data => {
    return $http.post("/collect/index/getRealMonthData", data);
};
export const getRealTransformerData = data => {
    return $http.post("/collect/index/getRealTransformerData", data);
};
export const getPointColumnKinds = data => {
    return $http.post("/collect/monitor/getPointColumnKinds", data);
};
export const getDayDataGf = data => {
    return $http.post("/collect/pv_collection/getDayData", data);
};
export const getMonthDataGf = data => {
    return $http.post("/collect/pv_collection/getMonthData", data);
};
export const getYearDataGf = data => {
    return $http.post("/collect/pv_collection/getYearData", data);
};
export const getExcelGf = data => {
    return $http.post("/collect/pv_collection/getExcel", data, {
        responseType: "blob"
    });
};
export const getPowerComparison = data => {
    return $http.post("/collect/index/getPowerComparison", data);
};
export const getRealTimeGfPower = data => {
    return $http.post("/collect/index/getRealTimeGfPower", data);
};
export const getRealTimeGfPowerList = data => {
    return $http.post("/collect/index/getRealTimeGfPowerList", data);
};
export const getDeptPowerComparison = data => {
    return $http.post("/collect/index/getDeptPowerComparison", data);
};
export const getMonthDeptPowerComparison = data => {
    return $http.post("/collect/index/getMonthDeptPowerComparison", data);
};
export const getSingleDeptPowerComparison = data => {
    return $http.post("/collect/index/getSingleDeptPowerComparison", data);
};
export const getIndexDeptList = data => {
    return $http.post("/collect/index/getDeptList", data);
};
export const getNbqList = data => {
    return $http.post("/collect/monitor/getNbqList", data);
};
export const getList = data => {
    return $http.post("/collect/gf_df/getList", data);
};
export const getDetail = data => {
    return $http.post("/collect/gf_df/getDetail", data);
};
export const getdfExcel = data => {
    return $http.post("/collect/gf_df/getExcel", data, {
        responseType: "blob"
    });
};
export const getDetailExcel = data => {
    return $http.post("/collect/gf_df/getDetailExcel", data, {
        responseType: "blob"
    });
};
export const getAreaPriceList = data => {
    return $http.post("/collect/area_price/getAreaPriceList", data);
};
export const savePrice = data => {
    return $http.post("/collect/area_price/savePrice", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
export const getTotalVal = data => {
    return $http.post("/collect/energy_storage/getTotalVal", data);
};
export const getEnergyIncome = data => {
    return $http.post("/collect/energy_storage/getIncome", data);
};
export const getYMDVal = data => {
    return $http.post("/collect/energy_storage/getYMDVal", data);
};
export const getPointListByPointClassId = data => {
    return $http.post("/collect/point_design/getPointListByPointClassId", data);
};
export const getBatterySoc = data => {
    return $http.post("/collect/monitor/getBatterySoc", data);
};
export const getRoofNbqList = data => {
    return $http.post("/collect/monitor/getRoofNbqList", data);
};
export const getMenuInfo = data => {
    return $http.post("/base/menu/getMenuInfo", data);
};
export const dataRepairData = data => {
    return $http.post("/collect/repair_es_data/save", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

export const getPointLossClassList = data => {
    return $http.post(
        "/collect/point_loss/getPointClassList",
        data
    );
};

export const getFxList = data => {
    return $http.post("/collect/monitor/getFxList", data);
};

export const getWarnHourList = data => {
    return $http.post("/collect/warn/getWarn_hourList", data);
};

export const getWarnInstantList = data => {
    return $http.post("/collect/warn/getWarn_instantList", data);
};

export const getRooms = data => {
    return $http.post("/collect/room/getRooms", data);
};
export const getRoomList = data => {
    return $http.post("/collect/room/getRoomList", data);
};
export const getRoomDetail = data => {
    return $http.post("/collect/room/getRoomDetail", data);
};
export const getRoomExcel = data => {
    return $http.post("/collect/room/getExcel", data, {
        responseType: "blob"
    });
};

export const getMaxTransformer = data => {
    return $http.post("/collect/needAnalysis/getMaxTransformer", data);
};

export const getMaxTransformerById = data => {
    return $http.post("/collect/needAnalysis/getMaxTransformerById", data);
};

export const getTransformerExcel = data => {
    return $http.post("/collect/needAnalysis/getExcel", data, {
        responseType: "blob"
    });
};